module.exports = __webpack_public_path__ + "img/Pipedrive@2x.494ec1cc.png";